import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import './style.scss'

export default class Count extends PureComponent {
    static propTypes = {
        count: PropTypes.number,
    }

    static defaultProps = {
        count: 0,
    }

    render() {
        const { count } = this.props

        return count > 0 && <div className={'event-count'}>{count}</div>
    }
}
